import * as actionTypes from '../actions/actionTypes';
/**
 * @type {TransactionState}
 */
const initialState = {
  total: 0,
  transactions:[],
  loading: false,
  error: null,
}

const transactionReducer = (state = initialState, action) => {
  const stateClone = {
    ...state
  };
  switch (action.type) {
    case actionTypes.FETCH_TRANSACTIONS: {
      stateClone.loading = true;
      break;
    }
    case actionTypes.FETCH_TRANSACTIONS_SUCCESS: {
      stateClone.loading = false;
      stateClone.transactions = action.payload.transactions;
      stateClone.total = action.payload.total;
      break;
    }

    case actionTypes.FETCH_TRANSACTIONS_ERROR: {
      stateClone.loading = false;
      stateClone.error = action.payload;
      break;
    }

    case actionTypes.LOGOUT: {
      return initialState;
    }

    default:
      ;
  }
  return stateClone;
};

export default transactionReducer;
